import React, { useContext } from "react";
import { I8nContext } from "../../../../../../../libs/i18n";
import { getImageURL, personFolder } from "../../../../../../../resources/api";
import styled from "styled-components";
import theme from "../../../../../../../resources/assets/theme";
import {IServerStatistics } from "../../../../../../../libs/redux";
import tw from "tailwind.macro";
// import "../../../../../../resources/assets/styles/main.scss";
import { colorTagGroup } from "../../../../../../../resources/styles/components/colorTagGroup";
import {getCheckAmountColor, getColor, getColorBorder , getColorTags, getValueForBorder} from "resources/helpers/helper";
import {MainStructure, ContainerPreview, WrapInfoPreview, Line, WrapNumPreview, WrapNumTagPreview, WrapTimePreview} from "../../../../../../../resources/styles/components/cards";
import { formatMoney } from "utils/text";

interface StyledProps {
  colors: {
    cardColor: string;
    overallColor: string;
  };
}

const CardStyle = styled.div`
  ${tw`flex w-full border-solid rounded border-2 sm:border-2 lg:border-4`}
  border-color: ${(props: StyledProps) => props.colors.cardColor};
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  .overall {
    color: ${(props) => props.colors.overallColor};
  }

  p {
    font-size: 1.2rem;
  }

  @media (max-width: 970px) {
    padding: 6px 0;
    p {
      font-size: 1rem;
    }
  }
  @media (max-width: 640px) {
    padding: 3px 0;
    p {
      font-size: 0.7rem;
    }
  }
`;

const CustomWrapInfoPreview = styled(WrapInfoPreview)`
  align-items: flex-start;
`;

const ServersCard: React.FC<IServerStatistics> = ({
  id,
  rating,
  name,
  avgAmount,
  guests,
  amount,
}) => {

  const colors = {
    cardColor: getCheckAmountColor(avgAmount),
    overallColor: getColor(rating),
  };

  return (
    <MainStructure>
      <CardStyle colors={colors}>
        <ContainerPreview>
          <ContainerPreview width={"30%"}>
            <img src={getImageURL(personFolder, `${id}.png`)} alt=""/>
            <CustomWrapInfoPreview width={"50%"}>
              <p>{name ? name.split(' ')[0] : '-'}</p>
            </CustomWrapInfoPreview>
          </ContainerPreview>
          <WrapNumPreview width={"15%"}>
            <Line /> 
              <p>{guests ? guests : "-"}</p>
            <Line width={'0'}/>
          </WrapNumPreview>
          <WrapNumPreview width={"20%"}>
            <Line /> 
              <p>{avgAmount ? formatMoney(avgAmount) : "-"}</p>
            <Line width={'0'}/> 
          </WrapNumPreview>
          <WrapNumPreview width={"20%"}>
            <Line /> 
              <p>{amount ? formatMoney(amount) : "-"}</p>
            <Line width={'0'}/> 
          </WrapNumPreview>
          <WrapNumPreview width={"15%"}>
            <Line /> 
              <p  className="overall">{rating ? rating : "-"}</p>
            <Line width={'0'}/>
          </WrapNumPreview>
        </ContainerPreview>
      </CardStyle>
    </MainStructure>
  );
};

export default ServersCard;
